import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { hostedLegalPageAssetsEnabled } from '../../util/legalPageAssets';

export const ASSET_NAME = 'terms-of-service';

/** Siehe PrivacyPolicyPage.duck.js — ohne den Schalter wird nichts geladen. */
export const loadData = (params, search) => dispatch => {
  if (!hostedLegalPageAssetsEnabled()) {
    return Promise.resolve();
  }
  const pageAsset = { termsOfService: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
